import styled, { css } from 'styled-components';

import { AspectRatioImage } from '@/components/AspectRatioImage/AspectRatioImage';
import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Grid } from '@/components/Grid';
import { Typography } from '@/components/Typography';
import { theme } from '@/theme';

export const Wrapper = styled(Box)`
  position: relative;
  height: 100%;
`;

export const ContentGrid = styled(Grid)`
  margin: 0 auto;
  margin-top: ${theme.spacing(5.3)};
  padding: ${theme.spacing(2.5)};
  grid-template-columns: 1fr;
  background-color: ${({ theme }) => theme.colors.lightGrey};
  ${theme.media.md.up} {
    padding: ${theme.spacing(5)};
    grid-template-columns: repeat(2, 1fr);
  }
`;
export const TextBox = styled(Flex)`
  justify-content: center;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing(2)};
  margin-left: ${({ theme }) => theme.spacing(0)};
  ${theme.media.md.up} {
    margin-left: ${({ theme }) => theme.spacing(1)};
  }
`;
export const ImageWrapper = styled(Flex)`
  ${theme.media.md.up} {
    padding: ${({ theme }) => theme.spacing(0)};
  }
`;
export const DescriptionWrapper = styled(Box)`
  max-width: 485px;
`;
export const BoutiqueStoryContainer = styled(Box)`
  background: ${theme.colors.lightGrey};

  ${({ theme }) => css`
    padding: 15px;
    ${theme.media.md.up} {
      padding: 32px 40px;
    }
  `};
`;
export const LimitedWidth = styled(Box)`
  margin: 0 auto;
  max-width: 1400px;
`;
export const FlexContainer = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    ${theme.media.md.up} {
      display: flex;
      align-items: center;
      flex-direction: row;
    }
  `};
`;
export const SlidersContainer = styled(Box)`
  ${({ theme }) => css`
    position: relative;
    margin-bottom: 10px;
    ${theme.media.md.up} {
      position: relative;
      margin-bottom: 0;
      max-width: 535px;
      min-width: 535px;
    }
  `};
  & > :first-child > :nth-child(2) {
    background-color: ${theme.colors.primaryBlue};
  }
  & > :first-child > :nth-child(2) > :first-child {
    background-color: ${theme.colors.primary};
  }
`;
export const TextContainer = styled(Box)`
  max-width: 430px;
  margin-right: auto;
  margin-left: auto;
`;
export const Text = styled(Typography)`
  font-weight: 400;
  letter-spacing: 0px;
  white-space: pre-wrap;
  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.openSans};
    color: ${theme.colors.default};
    font-size: ${theme.fontSizes.p2};
    line-height: 22px;
    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.p1};
      line-height: 24px;
    }
  `};
`;

export const StyledAspectRatioImage = styled(AspectRatioImage)`
  object-fit: cover;
  height: 100%;
`;
